/**
 * Guide step 6: start learning.
 */
import React from "react";
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { VText, VImage } from "form";

/**
 * Final onboarding slide that sends the learner into the course.
 */
const Guide6 = () => {

  const { t } = useTranslation('common');

  return <Box className="flex flex-col md:flex-row justify-center items-center w-full max-w-screen-xl mx-auto gap-10 md:py-10">
      <Box className="flex justify-center items-center md:w-6/12 w-full p-4 md:px-10 md:py-20">
        <VImage src={`${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/guide/guide6.svg`} className="w-full max-w-sm" draggable={false} />
      </Box>
      <Box className="flex flex-col gap-5 md:w-6/12 w-full">
        <VText className="text-4xl">{t("And there you have it, you know everything about your training!")}</VText>
        <VText className="text-2xl">{t("Have a question? Do you need help?")}</VText>
        <VText className="text-2xl">{t("contact us!")}</VText>
      </Box>
    </Box>;
};

export default Guide6;